import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, OFFER_ANCHOR, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="bg-brand-navy" data-id="element-55" data-mp="c4fw0l6gszqt">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-56" data-mp="83m6xohadewc">
        <p className="inline-block rounded bg-brand-orange px-2 py-0.5 font-display text-[0.62rem] font-bold uppercase tracking-[0.14em] text-white" data-id="element-57" data-mp="m46okhbgt4o9">
          Una última oportunidad
        </p>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.78rem] leading-snug text-white/80" data-id="element-58" data-mp="vv1blnwjc8ar">
          Puedes seguir pasando horas buscando actividades, códigos, circuitos y
          proyectos de Arduino para preparar cada nueva clase. O puedes comenzar
          hoy a trabajar con una ruta organizada que reúne contenidos y recursos
          prácticos en un mismo lugar.
        </p>
        <h2 id="cierre" className="mt-1.5 font-display text-base font-extrabold leading-tight text-white sm:text-xl" data-id="element-59" data-mp="2c4wq2u30imk1">
          No necesitas preparar todo desde cero para enseñar Arduino y Robótica.{' '}
          <span className="text-brand-yellow" data-id="element-60" data-mp="2m21c8twuyi0u">
            Necesitas una estructura clara y material que puedas adaptar a tus
            clases.
          </span>
        </h2>

        <Reveal className="mt-3 rounded-xl border-4 border-dashed border-brand-yellow bg-white p-3 text-brand-night" data-id="element-61" data-mp="2v4allgge45cn">
          <p className="font-display text-[0.8rem] font-black uppercase leading-tight text-brand-blue sm:text-sm" data-id="element-62" data-mp="301as1sh5ja4a">
            {PRODUCT_NAME}
          </p>
          <p className="mt-0.5 font-num text-lg uppercase tracking-wide" data-id="element-63" data-mp="39sf3wjbj6euw">
            6 Tomos + 5 Bonos
          </p>
          <p className="text-[0.75rem] text-brand-night/75" data-id="element-64" data-mp="3es1hitv9tx48">
            Valor de los bonos:{' '}
            <span className="text-brand-red line-through" data-id="element-65" data-mp="3islh043bhctj">{BONUS_VALUE}</span>
          </p>
          <p className="mt-1 font-num text-5xl leading-none text-brand-green sm:text-6xl" data-id="element-66" data-mp="1jo3ftcizfx1e">
            Hoy: {PRICE}
          </p>

          <CtaButton href={OFFER_ANCHOR} size="lg" className="mt-3" data-id="element-67" data-mp="1eqjtdpc4sdyd">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[0.68rem] font-medium text-brand-night/75" data-id="element-68" data-mp="1sirozdrohyvh">
            <span className="flex items-center gap-1" data-id="element-69" data-mp="22ebg7mvas9dw">
              <ZapIcon size={12} className="text-brand-orange" data-id="element-70" data-mp="22gxo5nm3oqwn" />
              Acceso Inmediato
            </span>
            <span className="text-brand-night/40" data-id="element-71" data-mp="1xi475l7luhrq">•</span>
            <span data-id="element-72" data-mp="2be80zdekgo3o">Entrega Digital</span>
            <span className="text-brand-night/40" data-id="element-73" data-mp="2bd6meyycdjh7">•</span>
            <span className="flex items-center gap-1" data-id="element-74" data-mp="27f8wftwqytcr">
              <ShieldCheckIcon size={12} className="text-brand-green" data-id="element-75" data-mp="h18dyz7uwrmd" />
              Garantía de 7 Días
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}